import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPersonUpdate } from '@lib-typing/person.interface';
import { AuthService } from '@lib-ui/auth/auth.service';
import { MessageService } from '@lib-services/message.service';
import { PersonService } from '@lib-services/person.service';

@Injectable({
    providedIn: 'root'
})
export class GeolocationService {
    constructor(
        private authService: AuthService,
        private messageService: MessageService,
        private userService: PersonService,
    ) { }
    getCurrentPosition(): Observable<any> {
        return new Observable((observer) => {
            if ('geolocation' in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        observer.next(position);
                        observer.complete();
                    },
                    () => {
                        observer.error('Геолокация не поддерживается http протоколом.');
                    }
                );
            } else {
                observer.error('Геолокация не поддерживается этим браузером.');
            }
        });
    }

    getGeoLocation(): void {
        this.getCurrentPosition().subscribe({
            next: position => {
                this.setGeoLocation(
                    this.authService.user().dataForUpdateCoordinates(position.coords.latitude, position.coords.longitude));
            },
            error: err => this.messageService.errorMessage(err),
        });
    }

    setGeoLocation(user: IPersonUpdate): void {
        if (!user.id) {return;}

        this.userService.updateGeolocation(user).subscribe({
            error: err => this.messageService.errorMessage(err.error.message),
        });
    }
}
